import React from 'react'
import Link from 'next/link'
import Logo from '@assets/svgs/logo'

const logo = (
  <Link href="/">
    <a aria-label="home page" data-cy="top-navigation-home">
      <Logo />
    </a>
  </Link>
)

export const HEADER_ARGS = {
  links: [
    {
      text: 'Locations',
      href: '/locations',
      id: 'locations',
    },
    {
      text: 'Help Center',
      href: '/help',
      id: 'help',
    },
  ],
  dropdownLinks: [
    {
      text: 'Locations',
      href: '/locations',
      mobileOnly: true,
      id: 'locations',
    },
    {
      text: 'Help Center',
      href: '/help',
      mobileOnly: true,
      id: 'help-center',
    },
    {
      text: 'Check Status',
      href: '/status',
      id: 'status',
    },
    {
      text: 'Look Up KTN',
      href: '/ktn-lookup',
      id: 'ktn-lookup',
    },
  ],
  logo,
}

export type HeaderArgs = typeof HEADER_ARGS

export const UPDATED_HEADER_ARGS: HeaderArgs = {
  links: [
    {
      text: 'Check Status',
      href: '/status',
      id: 'status',
    },
    {
      text: 'Look Up KTN',
      href: '/ktn-lookup',
      id: 'ktn-lookup',
    },
    {
      text: 'Locations',
      href: '/locations',
      id: 'locations',
    },
    {
      text: 'Help Center',
      href: '/help',
      id: 'help',
    },
  ],
  dropdownLinks: [
    {
      text: 'Locations',
      href: '/locations',
      mobileOnly: true,
      id: 'locations',
    },
    {
      text: 'Help Center',
      href: '/help',
      mobileOnly: true,
      id: 'help-center',
    },
    {
      text: 'Check Status',
      href: '/status',
      mobileOnly: true,
      id: 'status',
    },
    {
      text: 'Look Up KTN',
      href: '/ktn-lookup',
      mobileOnly: true,
      id: 'ktn-lookup',
    },
  ],
  logo,
}

// The flag is undefined at export; the updated menu matches its production value.
export const getLookupFlowUpdatedMenu = (
  updatedLookupFlow?: boolean
): HeaderArgs =>
  updatedLookupFlow === false ? HEADER_ARGS : UPDATED_HEADER_ARGS
